export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-primary-500 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-10 lg:p-12 text-center lg:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-medium mb-4 whitespace-nowrap">
                随时随地看漫画
              </span>
              <h2 className="text-xl md:text-2xl font-bold text-background-50 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                虫虫漫画 · 移动端阅读
              </h2>
              <p className="text-sm text-background-50/80 leading-relaxed mb-6 max-w-[420px] mx-auto lg:mx-0">
                无需下载App，手机浏览器打开即可畅享全部漫画内容。下拉式阅读在移动端体验更佳，
                躺在床上、通勤路上，随时随地看韩漫日漫国漫。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 text-primary-600 rounded-lg font-semibold text-sm cursor-pointer whitespace-nowrap">
                  <i className="ri-smartphone-line"></i>
                  手机浏览器打开
                </div>
                <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50/20 text-background-50 rounded-lg font-semibold text-sm border border-background-50/30 cursor-pointer whitespace-nowrap">
                  <i className="ri-tablet-line"></i>
                  平板端体验
                </div>
              </div>
            </div>

            <div className="flex-shrink-0 w-full lg:w-[360px] px-8 md:px-10 lg:px-0 lg:pr-12 pb-8 lg:pb-0">
              <div className="relative mx-auto w-[200px]">
                <div className="aspect-[9/16] rounded-2xl overflow-hidden bg-background-50/10 border-2 border-background-50/20">
                  <img
                    src="https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20a%20colorful%20webtoon%20comic%20reading%20interface%20in%20vertical%20scroll%20format%2C%20Korean%20manhwa%20style%20artwork%20on%20screen%2C%20warm%20coral%20and%20peach%20color%20accents%2C%20clean%20mobile%20UI%20design%2C%20soft%20cream%20background%2C%20modern%20flat%20illustration%20style&width=720&height=1280&seq=app-mobile-01&orientation=portrait"
                    alt="虫虫漫画移动端阅读界面 - 手机下拉式漫画阅读体验"
                    className="w-full h-full object-cover"
                    title="虫虫漫画移动端阅读体验"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}